<template>
  <li class="list-item">
    <b-card>
      <div class="single-item p-0">
        <div class="d-flex">
          <div :class="['item-image', 'rounded', 'mr-2', hasBaseImage(blog) ? null : 'default-image']">
            <img
              v-show="hasBaseImage(blog)"
              :src="blog.base_image"
              :class="{ 'image-placeholder': !hasBaseImage(blog) }"
              :alt="`${blog.name} image`"
            />
          </div>
          <section class="d-flex w-100 ml-2">
            <div class="d-flex flex-column w-100">
              <h6 class="font-size-large my-2">
                <a class="text-dark" :href="getBlogLink(blog)">{{ blog.name }}</a>
              </h6>
              <summary>
                <p class="text-muted" v-text="blog.short_description + '...'"></p>
              </summary>
              <div class="my-3">
                <b-button
                  class="text-uppercase px-3"
                  variant="outline-primary"
                  :href="getBlogLink(blog)"
                  size="sm"
                  squared
                >
                  Read more
                </b-button>
              </div>
              <div>
                <span class="text-muted">The entry was posted on </span>
                <span>{{ blog.created_at }}</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-card>
  </li>
</template>

<script>
export default {
  name: 'BlogCard',
  props: { blog: { type: Object, required: true } },
  methods: {
    getBlogLink(blog) {
      return `/blogs/${blog.slug}`
    },
    hasBaseImage(item) {
      return item.base_image !== null && item.base_image !== ''
    },
    baseImage(item) {
      if (this.hasBaseImage(item)) return item.base_image

      return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.single-item {
  position: relative;
  display: flex;
  padding: 6px 20px;
  flex-direction: column !important;
}

.item-image {
  width: 230px;
  min-height: 230px;
  min-width: 230px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  -webkit-box-shadow: 5px 5px 5px 2px rgba(108, 117, 125, 0.35);
  -moz-box-shadow: 5px 5px 5px 2px rgba(108, 117, 125, 0.35);
  box-shadow: 5px 5px 5px 2px rgba(108, 117, 125, 0.35);
  &.default-image {
    background: url('/themes/storefront/public/images/no-image.png') no-repeat top center;
  }

  img {
    min-width: 230px;
    object-fit: cover;
  }

  .image-placeholder {
    width: 230px;
    min-width: 230px;
  }
}
</style>
